import { api, endpoint } from '@/plugins/axios'

const getSalaryStructure = async staffId => {
  const res = await api.get(`${endpoint.PAYROLL_STRUCTURE}/${staffId}`)

  return res
}

const saveSalaryStructure = async (staffId, payload) => {
  const res = await api.put(`${endpoint.PAYROLL_STRUCTURE}/${staffId}`, payload)

  return res
}

const setSalaryStructureActive = async (staffId, active) => {
  const res = await api.put(`${endpoint.PAYROLL_STRUCTURE}/${staffId}/active`, { active })

  return res
}

const getPayrollSettings = async () => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(endpoint.PAYROLL_SETTINGS, { params: { institutionId } })

  return res
}

const updatePayrollSettings = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.put(endpoint.PAYROLL_SETTINGS, { institutionId, ...payload })

  return res
}

const generatePayrollRun = async payload => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.post(endpoint.PAYROLL_RUN_GENERATE, { institutionId, ...payload })

  return res
}

const finalizePayslip = async payslipId => {
  const res = await api.put(`${endpoint.PAYROLL_RUN}/${payslipId}/finalize`)

  return res
}

const finalizeBatch = async payslipIds => {
  const res = await api.put(endpoint.PAYROLL_RUN_FINALIZE_BATCH, payslipIds)

  return res
}

const getPayslip = async payslipId => {
  const res = await api.get(`${endpoint.PAYROLL_PAYSLIP}/${payslipId}`)

  return res
}

const getRegister = async params => {
  const institutionId = localStorage.getItem('institutionId')
  const res = await api.get(endpoint.PAYROLL_REGISTER, { params: { institutionId, ...params } })

  return res
}

export default {
  getSalaryStructure,
  saveSalaryStructure,
  setSalaryStructureActive,
  getPayrollSettings,
  updatePayrollSettings,
  generatePayrollRun,
  finalizePayslip,
  finalizeBatch,
  getPayslip,
  getRegister,
}
